export default "__VITE_ASSET__hle4xs2L__"